"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/fr");

require("moment/locale/de");

require("moment/locale/es");

require("moment/locale/pt");

require("moment/locale/zh-cn");

require("moment/locale/it");

require("moment/locale/ko");

require("moment/locale/ja");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Locales, supported by Hub at moment
// Add more as needed
// French
// German
// Spanish, Castilian
// Portuguese
// Simplified Chinese
// Italian
// Korean
// Japanese
var DEBUG_HOSTS = ['localhost', 'app.hub.infl.dev', 'qalocize.influitiveqa.com'];
var DEBUG_MODE = DEBUG_HOSTS.indexOf(window.location.hostname) > -1;
var DEFAULT_LANG = 'en';
/* eslint-disable complexity */

var i18nMoment = function i18nMoment(options) {
  var hubLang = window._infl && window._infl.hub && window._infl.hub.lang;
  var queryLang = (0, _utils.getQueryVariable)('lang');
  var defaultLanguage = options.lang || hubLang || DEFAULT_LANG;
  var lang = DEBUG_MODE ? queryLang || defaultLanguage : defaultLanguage;

  _moment.default.locale((lang || DEFAULT_LANG).replace(/_/g, '-'));

  return _moment.default;
};

var _default = i18nMoment;
exports.default = _default;